export default __webpack_public_path__ + "static/media/KOD0142-min.963ab946.webp";